module.exports = __webpack_public_path__ + "h5/img/shangjiao.8db6b203.png";